<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "TicketQueue",
  data() {
    return {}
  },
  props: {},
  methods: {},
})
</script>

<template>
  <div class="ticket-queue">
    <div class="queue-header">
      <h5 class="mb-0">Очередь</h5>
    </div>
    <div class="queue-content">
    </div>
  </div>
</template>

<style scoped lang="scss">
.ticket-queue {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background: white;
  overflow: hidden;
}

.queue-header {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
}

.queue-content {
  flex: 1;
  overflow-y: auto;
  padding: 0.5rem;
}
</style>